

export const UserPrivacy = ()=>{
    return(
        <div className="content-wrapper" style={{margin:"13px"}}>
        <div>
            <div className="title">有律可寻在线隐私保护政策</div>
        </div>
        <div className="public_container">
            <span className="public_item">版本发布日期 2021年11月20日</span>
            <span className="public_item">生效日期 2021年11月20日</span>
        </div>
        <div className="part3">
            <p className="qy">
                前言
            </p>
            <p className="desc_block">
                湖南有律可寻网络科技有限公司与旗下各关联公司和产品（以下统称&quot;有律可寻c&quot;或者c&quot;我们c&quot;）非常重视用户的隐私和个人信息保护。您在使用我们的产品和服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私保护政策》（以下简称c&quot;本政策c&quot;或者“本隐私政策”）向您说明在您接受我们的产品服务时，我们如何收集、使用、储存、共享和转让这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。
            </p>
            <p className="desc_block">
                我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
            </p>
            <p className="desc_block">
                <b>
                    请在使用我们的服务前，仔细阅读并了解本政策。如果您不同意本政策的内容，将导致我们无法为您提供完整的服务，同时也请您立即停止使用我们的产品和服务。您使用或继续使用我们提供的产品和/或服务，则表示您同意我们按照本政策收集、使用、储存和分享、披露、保护您的个人信息。如您对本政策内容有任何疑问、意见或建议，请通过文末的方式与我们联系。
                </b>
            </p>
            <p className="desc_block">
                当您点击确认同意本政策，即表示您已充分阅读、理解且接受本政策的全部内容，并与我们达成一致，本政策对您及我们均具有法律约束力。
            </p>
        </div>
        <div className="xxnr">
            <div className="part4">
                <p className="qy">本《用户隐私权保护政策》将帮助您了解以下内容</p>
                <ul className="ula">
                    <li><a href="#1"><span>1.</span>本政策适用范围、相关词语涵义</a></li>
                    <li><a href="#2"><span>2.</span>我们如何收集、存储和使用您的个人信息</a></li>
                    <li><a href="#3"><span>3.</span>我们如何使用 Cookie 和同类技术</a></li>
                    <li><a href="#4"><span>4.</span>我们如何共享、转让、公开披露您的个人信息</a></li>
                    <li><a href="#5"><span>5.</span>我们如何保护您的个人信息</a></li>
                    <li><a href="#6"><span>6.</span>您的权利</a></li>
                    <li><a href="#7"><span>7.</span>我们如何处理儿童的个人信息</a></li>
                    <li><a href="#8"><span>8.</span>您的个人信息如何在全球范围转移</a></li>
                    <li><a href="#9"><span>9.</span>本政策如何更新</a></li>
                    <li><a href="#10"><span>10.</span>如何联系我们</a></li>
                </ul>

                <p className="one" id="1">
                    1.1本政策适用范围
                </p>

                <p className="desc_block">当您使用我们的任何产品和服务时，本政策即适用，无论该产品和服务是否单独设置了隐私条款，也无论您是浏览用户（访客）还是注册登录用户。请您注意，本政策不适用于以下情况：</p>
                <p className="desc_block">
                    通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息；
                </p>
                <p className="desc_block">
                    通过在我们服务中进行广告服务的其他公司和机构所收集的信息。</p>
                <p className="one">
                    1.2相关词语涵义
                </p>
                <p className="qyc">
                    个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
                    <b>本隐私政策中涉及的个人信息包括自然人的基本资料（包括姓名、生日、性别、住址、电话号码、电子邮箱）、个人身份信息（包括身份证件号码）、个人生物识别信息（包括指纹、面部特征、录音）、网络身份标识信息（包括系统账号、IP地址、邮箱地址以及与前述有关的密码、口令、口令保护答案）、个人财产信息（包括银行账号、口令、交易和消费记录、虚拟货币、虚拟交易、兑换码等虚拟财产信息）、通讯录信息、个人上网记录（包括网站浏览记录、软件使用记录）、个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备标识符、设备唯一识别码、android ID、ios ID、IMEI、IMSI、软件安装列表 ）、个人位置信息（包括大概地理位置、精确定位信息）。</b>我们实际具体收集的个人信息种类以下文描述为准。
                </p>
                <p className="qyc">
                    <b>个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本隐私政策中涉及的个人敏感信息包括您的个人财产信息、个人身份信息（包括身份证件号码）、个人生物识别信息、网络身份标识信息、通讯录信息、精准定位信息、收货地址、14岁以下（含）儿童的个人信息。我们实际具体收集的个人敏感信息种类以下文描述为准。您同意您的个人敏感信息按本政策所述的目的和方式来处理。</b>
                </p>
                <p className="qyc">
                    设备：是指可用于访问我们的产品和/或服务的装置，例如台式计算机、笔记本电脑、平板电脑或智能手机。
                </p>
                <p className="qyc">唯一设备标识符（专属ID或UUID）：是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（例如手机的IMEI号）。唯一设备标识符有多种用途，其中可在不能使用 Cookie（例如在移动应用程序中）时用以提供广告。</p>
                <p className="qyc">IP地址：每台上网的设备都会指定一个编号，称为互联网协议( IP )地址。这些编号通常都是根据地理区域指定的。IP地址通常可用于识别设备连接至互联网时所在的位置。</p>
                <p className="qyc">SSL：SSL（Secure Socket Layer）又称为安全套接层，是在传输通信协议（TCP/IP）上实现的一种安全协议。SSL支持各种类型的网络，同时提供三种基本的安全服务，均通过使用公开密钥和对称密钥技术以达到信息保密的效果。</p>
                <p className="qyc">Cookie：Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如：Web Beacon、Proxy、嵌入式脚本等。</p>
                <p className="qyc">账号：当您注册账号并向我们提供一些个人信息，您就可以更好的使用我们的服务。当您使用我们的服务时，系统会利用这些账号信息对您进行身份验证，以防止未经授权的人员访问您的账号。</p>
                <p className="qyc">去标识化/匿名化：是指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体，且处理后的信息不能被复原的过程。</p>
                <p className="qyc">服务器日志：通常情况下，我们的服务器会自动记录您在访问网站时所发出的网页请求。这些“服务器日志”通常包括您的网络请求、互联网协议地址、浏览器类型、浏览器语言、请求的日期和时间及可以唯一识别您的浏览器的一个或多个Cookie。</p>
                <p className="qyc">共享信息：指您在我们的服务中自愿与您的社交网络及使用该服务的所有用户公开分享的有关您的信息，或其他方分享的与您有关的信息，例如，他们上传或发布的信息包含有关您的信息，以及他们发送给您和其他使用我们服务的用户的通讯信息之中包含的有关您的信息。</p>
                <p className="qyc">非个人身份信息：指任何与您有关但实际上不可直接或间接辨认您身份的信息，包括以汇集、匿名或化名方式提供的个人信息。您知悉并同意，无法识别出您的个人身份的信息不属于个人信息。</p>

                <p className="one" id="2">
                    2.1我们收集的信息
                </p>
                <p className="one" >
                    2.1.1您提供的信息
                </p>
                <div style={{fontWeight: "bold"}}>
                    <p className="pyc">
                        账号注册
                    </p>
                    <p className="desc_block">
                        创建账号时，您需要提供手机号码（个人敏感信息，用于接受验证码匹配个人身份）。您只有提供真实准确的上述信息，才能成功注册账号并使用产品和/或服务的核心功能。如果您选择不提供上述为实现核心产品功能的必备信息，或将导致我们无法为您提供该核心产品功能。在您主动注销账号之后，我们将根据法律的要求删除您的个人信息，或使其匿名化处理。
                    </p>
                    <p className="desc_block">
                        我们的产品支持您使用第三方平台的账号（微博账号/QQ账号/微信账号/百度账号）进行登录，如您使用第三方平台的账号登录的，我们将根据您的授权获取该第三方账号下的相关信息（包括：用户名、昵称、头像等）以及身份验证信息（个人敏感信息）。我们承诺，收集上述信息是用于为您提供账号注册、登录服务以及保障您的账号安全，防范安全风险。如您拒绝授权此类信息，则您将无法使用第三方平台的账号登录我们平台，但不影响我们提供的其他产品和服务的正常使用。
                    </p>
                    <p className="desc_block">
                        同时，您需理解，手机号码或电子邮箱地址和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是基于法律法规的相关要求，如您拒绝提供可能导致您无法注册账号并使用相关产品功能，请您谨慎考虑后再选择是否提供。
                    </p>
                </div>
                <p className="one">
                    （一） 帮助您成为我们的会员
                </p>
                <p className="qyc">
                    1、基础会员服务
                </p>
                <p className="desc_block">
                    我们通过有律可寻平台及旗下和关联产品账户为您提供基础用户服务。为注册成为会员并使用我们的会员服务，您需要提供手机号码、拟使用的会员名和密码用于创建有律可寻平台账户。如果您仅需使用浏览、搜索服务，您不需要注册成为我们的会员及提供上述信息。
                </p>
                <p className="desc_block">
                    对于需要通过有律可寻平台账户才能使用的服务，我们可能会根据您提供的上述信息校验您的会员身份，确保我们是在为您本人提供服务。
                </p>
                <p className="one">
                    （二） 为您提供商品或服务信息展示
                </p>
                <p className="desc_block">
                    在您使用我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动收集您的使用情况并存储为网络日志信息，包括：
                </p>
                <p>
                    <b>
                        设备信息：我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）。
                    </b>
                </p>
                <p>
                    <b>
                        服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、收藏、交易、售后、关注分享信息、发布信息，以及IP地址、浏览器类型、电信运营商、访问日期和时间。
                    </b>
                </p>
                <p className="desc_block">
                    请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。
                </p>
                <p className="desc_block">
                    此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。
                </p>
                <p className="one">
                    （三） 为您提供收藏、关注与分享功能
                </p>
                <p className="desc_block">
                    在您浏览我们网站或客户端的过程中，您可以选择对感兴趣的商品及/或服务进行收藏，在您使用上述功能的过程中，我们会收集包括您的收藏的记录、分享历史在内的服务日志信息用于实现上述功能及其他我们明确告知的目的。
                </p>
                <p className="one">
                    （四） 客服及争议处理
                </p>
                <p className="desc_block">
                    当您在使用我们的客服、产品或服务的售后功能时，为了保障您的账号与系统安全，我们可能需要您先行向我们提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。同时，为了方便与您联系或帮助您解决问题，我们可能还需要您提供姓名、手机号码、电子邮件及其他联系方式等个人信息（个人敏感信息）。另外，我们还会收集您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）、与您的需求相关联的其他必要信息。我们收集这些信息是为了帮助您解决问题，如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。
                </p>
                <p className="one">
                    （五） 为您提供评论、问答等信息公开发布功能
                </p>
                <p className="desc_block">
                    您主动对我们的产品/服务进行评价或发布其他内容（如发表评论信息）时，我们将收集您发布的信息，并展示您的昵称、头像和发布内容。如您选择以匿名方式发布评价信息时，我们将不展示您的昵称、头像。您还可以通过主动上传图片、视频等方式授权我们访问您的相机、照片和麦克风，以便于您通过拍照、拍视频、上传照片或上传视频等方式发布内容。当您需要关闭该功能时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。
                </p>
                <p className="one">
                    （六） 为您提供安全保障
                </p>
                <p className="desc_block">
                    为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或有律可寻相关协议规则的情况，我们可能使用或整合您的会员信息、交易信息、设备信息、服务日志信息取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
                </p>
                <p className="one">
                    （七） 为您提供其他附加服务
                </p>
                <p className="desc_block">
                    为向您提供更便捷、更优质、个性化的产品及/或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。如果您不提供这些信息，不会影响您使用有律可寻的浏览、搜索、购买等基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括： 1、基于位置信息的个性化推荐服务：我们会在您开启位置权限后访问获取您的位置信息，根据您的位置信息为您提供更契合您需求的页面展示、产品及/或服务，比如向您推荐附近的咨询师信息。 2、基于相机/摄像头的附加服务：您可在开启相机/摄像头权限后使用该功能咨询师视频互动，拍摄照片用于评价、分享，以及特定场景下经您授权的人脸识别等功能。当您使用该附加功能进行人脸识别时我们会收集您的面部特征，且严格在经您授权同意的范围内使用，未来如我们拟使用您的面部信息为您提供其他产品及/或服务功能的，我们会再次与您确认。
                </p>
                <p className="desc_block">
                    3、基于相册（图片库/视频库）的图片/视频访问及上传的附加服务：您可在开启相册权限后使用该功能上传您的照片/图片/视频，以实现更换头像、发表评论/分享等功能。我们可能会通过您所上传的照片/图片来识别您需要购买的服务，或使用包含您所上传照片或图片的评论信息。
                </p>
                <p className="desc_block">
                    4、基于麦克风的语音技术相关附加服务：您可在开启麦克风权限后使用麦克风实现咨询互动功能。请您知晓，即使您已同意开启麦克风权限，我们也仅会在您主动点击客户端内麦克风图标或录制视频时通过麦克风获取语音信息。
                </p>
                <p className="desc_block">
                    5、基于您进入有律可寻法律咨询app时选择的分类、性别、年龄，根据您的偏好，我们会主动给你推荐合适的律师给您展示。
                </p>
                <p className="desc_block">
                    您理解并同意，上述附加服务可能需要您在您的设备中开启您的位置信息 （地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）的访问权限，以实现这些权限所涉及信息的收集和使用。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
                </p>
                <p className="one">
                    2.1.2其他方分享的您的信息
                </p>
                <p className="desc_block">
                    <b>
                        您理解并知悉，您向外部第三方（有律可寻旗下关联公司不在此限）提供的个人信息，或外部第三方收集的您的个人信息，我们无法获取，更不会使用非常规方式（如：恶意干预对方系列APP数据）擅自以软件程序获得您的个人信息。为能向您提供更优质的服务，同时为能确认交易状态及为您提供售后与争议解决服务，经您授权后我们会通过您选择的交易对象和交易直接涉及的第三方信息系统、支付机构等收集与交易进度相关的您的交易、支付相关信息，以便于我们处理您的订单并保证服务的顺利完成，或者更好地预防诈骗、刷单等恶意行为。我们会依据法律法规的要求以及与第三方的约定，以弹窗方式经您授权后从我们的关联公司、合作伙伴获得您的有关信息，并对其信息来源的合法性进行确认后使用您的这些信息。如您在授权使用第三方账号登录时，平台会从第三方获取您共享的账号信息（如头像、昵称），并在您同意本隐私政策后、在您使用相关功能时，将您的第三方账号与我们的账号进行绑定。
                    </b>
                </p>
                <p className="desc_block">
                    我们的专业安全团队对个人信息将进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。
                </p>
                <p className="one">
                    2.1.3我们自动获取的您的信息
                </p>
                <b>
                    提升个性化的用户体验
                </b>
                <p className="desc_block">
                    在您事先同意的情况下，我们将基于分析您使用我们产品和/或服务的情况、广告优化的目的，自动采集您的信息或获得系统权限，可能包括如下信息：
                </p>
                <p>
                    <b>
                        日志信息：指您使用我们服务时，系统可能会通过cookies、web beacon或其他方式自动采集的技术信息，包括：
                    </b>
                </p>
                <p>
                    <b>
                        设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本IMEI以及IDFA；
                    </b>
                </p>
                <p>
                    <b>
                        您在使用我们服务时搜索和浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；
                    </b>
                </p>
                <p>
                    <b>
                        有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；
                    </b>
                </p>
                <p>
                    <b>
                        您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；
                    </b>
                </p>
                <p>
                    <b>
                        您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点。
                    </b>
                </p>
                <p>
                    <b>
                        网络信息，例如使用的移动网络运营商网络数据信息、WIFI信号信息、宽带数据信息。
                    </b>
                </p>
                <p>
                    <b>
                        请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
                    </b>
                </p>
                <p>
                    <b>
                        位置信息：指您开启设备定位功能并使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，包括：
                    </b>
                </p>
                <p>
                    <b>
                        您通过具有定位功能的移动设备使用我们的服务时，我们通过GPS或WiFi等方式收集的您的地理位置信息；
                    </b>
                </p>
                <p>
                    <b>
                        您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。
                    </b>
                </p>
                <p>
                    <b>
                        录音、录像、照片信息：指您使用我们的特定功能（例如语音搜索、扫码、拍照等）时，在获得您的授权后，我们收集的信息。拒绝提供该信息仅会使您无法使用上述功能，但不影响您正常使用我们的服务的其他功能。此外，您可随时关闭相关功能。
                    </b>
                </p>
                <p>
                    <b>
                        其他：我们希望提供给您的服务是完善的，所以我们会不断改进我们的服务，包括技术。这意味着我们的服务可能会经常推出新功能，可能需要收集新的信息。如果我们收集的个人数据或使用方式出现重大变化或调整，我们会通过适当的方式通知您并且可能会修订本政策。
                    </b>
                </p>
                <p>
                    <b>
                        您需知悉，我们将会在征求您同意的前提下开启上述功能，您可以选择不向我们提供上述功能实现所相关的个人信息，或者拒绝打开相应的系统权限，在此情况下您将无法体验上述服务。同时，您可随时通过系统设置管理、拒绝 或关闭相关权限，您关闭权限即代表您取消了这些授权，我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与此授权所对应的服务和/ 或功能，如您继续使用这些功能您需重新开启访问权限。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。在此我们保证，您未选择上述服务或功能，并不影响您正常使用我们为您提供的其他基础功能。
                    </b>
                </p>
                <p className="one">
                    2.2个人信息的存储
                </p>
                <p className="qyc">
                    2.2.1存储地点：我们依照法律法规的规定，将您的个人信息存储于中华人民共和国境内（包含港澳台）。如需跨境存储，我们会单独再征得您的授权同意；
                </p>
                <p className="qyc">
                    2.2.2存储期限：除法律或相关法规另有约定外（例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；《教育部等六部门关于规范校外线上培训的实施意见》规定，用户行为日志须留存1年以上），我们在为提供我们的服务之目的所必需的最短期限内保留您的个人信息，超过该等保存期限，将对个人信息进行删除或者匿名化处理（如您为未成年人，在您的个人信息超出保留期间后，我们会按照相关法律法规要求对您的个人信息进行相应处理）。对于已匿名化的信息的存储期限和处理，我们无需取得您的授权同意，也无需做出通知。我们判断前述期限的标准包括：
                </p>
                <p className="desc_block">
                    （1）完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；
                </p>
                <p className="desc_block">
                    （2）保证我们为您提供服务的安全和质量；
                </p>
                <p className="desc_block">
                    （3）您是否同意更长的留存期间；
                </p>
                <p className="desc_block">
                    （4）是否存在保留期限的其他特别约定。
                </p>
                <p className="one">
                    2.3我们如何使用您的信息
                </p>
                <p className="desc_block">
                    收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，您的信息将用于下列用途，如我们需将收集到的相关信息用于新的目的、范围或实际传输方式与本协议约定不一致时，我们将以应用内弹窗的方式通知到您并取得您的明示同意：
                </p>
                <p className="qyc">
                    用于数据分析，以便向您提供更加优质的服务；
                </p>
                <p className="qyc">
                    在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
                </p>
                <p className="qyc">
                    帮助我们设计新服务，改善我们现有服务；
                </p>
                <p className="qyc">
                    让您参与有关我们产品和服务或通过我们的产品和服务发起的调查，是否参与调查将由您全权决定，并且由您自行选择提供哪些信息；
                </p>
                <p className="qyc">
                    出于安全、合法调查等目的；
                </p>
                <p className="qyc">
                    我们可能使用您的数据做数据汇总、分析、挖掘（包括商业化利用），但这些信息都采用匿名的方式，不能识别您的身份；
                </p>
                <p className="qyc">
                    我们可能会收集您的订单信息、浏览信息、您的兴趣爱好（您可以在账户设置中选择）进行数据分析以形成间接用户画像，用来将您感兴趣的商品或服务信息展示给您。如果您不希望参加用户信息的收集，请您通过文末的方式联系客服人员予以处理。
                </p>
                <p className="desc_block">
                    为了让我们的用户有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能需要通过语音通话的方式回答您的疑问、提示课程信息以及向您提供其他更优质的服务。
                </p>
                <p className="desc_block">
                    请您注意，除非您删除或撤回同意（即通过系统设置拒绝我们的收集和使用），您在使用我们的服务时所提供的所有个人信息，将在您使用我们的服务期间持续授权我们在符合本政策的范围内使用。在您注销账号后，我们将根据您的要求删除您的个人信息，或做匿名化处理，但法律法规另有规定的除外。
                </p>
                <p className="one">
                    2.4征得授权同意的例外
                </p>
                <p className="desc_block">
                    根据相关法律法规规定及国家标准，以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：
                </p>
                <p className="desc_block">
                    （1）与国家安全、国防安全直接相关的；
                </p>
                <p className="desc_block">
                    （2）与公共安全、公共卫生、重大公共利益直接相关；
                </p>
                <p className="desc_block">
                    （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；
                </p>
                <p className="desc_block">
                    （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
                </p>
                <p className="desc_block">
                    （5）所收集的个人信息是您自行向社会公众公开的；
                </p>
                <p className="desc_block">
                    （6）从合法公开披露的信息中收集个人信息的，如：合法的新闻报道、政府信息公开等渠道；
                </p>
                <p className="desc_block">
                    （7）根据您的要求签订和履行合同所必须的；
                </p>
                <p className="desc_block">
                    （8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现或处置产品或服务的故障；
                </p>
                <p className="desc_block">
                    （9）为新闻单位或学术研究机构基于新闻报道、公共利益开展统计或学术研究所必要等，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理，且数据接收方无法复原并重新识别个人信息的；
                </p>
                <p className="desc_block">
                    （10）法律法规规定的其他情形。
                </p>
                <p className="one" id="3">
                    3我们如何使用 Cookie 和同类技术
                </p>
                <p className="one">
                    3.1Cookie
                </p>
                <p className="desc_block">
                    为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好或购物篮内的商品等数据。您在注册账号或使用本服务的过程中，需要提供一些必要的信息，例如：为改善SDK性能及排查SDK异常，会获取、处理并可能会存储您的IMEI/OAID、IMSI、ICCID、MAC、IP、手机型号、手机厂商、系统版本等信息。若国家法律法规或政策有特殊规定的，您需要提供真实身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。
                </p>
                <p className="desc_block">
                    我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。
                </p>
                <p className="one">
                    3.2网站信标和像素标签
                </p>
                <p className="desc_block">
                    除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。
                </p>
                <p className="one">
                    3.3软件安装列表
                </p>
                <p className="desc_block">
                    仅用于软件启动时，检测我们软件当前进程是否是主进程。融云会启动子进程用于实时消息聊天，融云SDK只能在主进程初始化，不能重复注册，所以需要判断当前进程是否为主进程。
                </p>
                <p className="one" id="4">
                    4.我们如何共享、转让、公开披露您的个人信息
                </p>
                <p className="one">
                    4.1共享
                </p>
                <p className="desc_block">
                    <b>
                        您同意，我们可能与我们的关联公司分享您必要的个人信息，以提供和发展我们的产品和服务。除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        在以下情形中，您可以向我们提出删除个人信息的请求：
                    </b>
                </p>

                <p className="desc_block">
                    <b>
                        （1）事先获得您明确的同意或授权；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （2）根据法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下对外提供；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （3）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （4）我们以及我们的关联公司可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、以及为我们提供位置数据的地图服务供应商）分享，用作下列用途，但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理如要改变个人信息的处理目的，将再次征求您的授权同意，并且无权将共享的个人信息用于任何其他用途：
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        向您提供我们的服务；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        实现c&quot;我们如何使用您的信息c&quot;部分所述目的；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        履行我们在《用户服务条款》或本《隐私保护政策》中的义务和行使我们的权利；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        理解、维护和改善我们的服务；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （5）应您要求为您处理您与他人的纠纷或争议。
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        我们的合作伙伴包括以下类型：
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （1）商品或技术服务的供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。这些支持包括为我们提供支付服务、数据处理等。我们共享这些信息的目的是可以实现我们产品与/或服务的核心功能；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （2）第三方SDK类服务商。我们的产品中可能会包含第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如以嵌入代码、插件等形式）。我们对接入的相关第三方SDK在以下列明：
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        创蓝闪验SDK：由上海创蓝云智信息科技股份有限公司提供一键登录服务，我们可能会将您的手机号信息提供给上海创蓝云智信息科技股份有限公司(此产品的隐私政策条款，用于为您提供一键登录服务，可参考 
                        <a href="http://shanyan.253.com/document/details?cid=91&lid=639&pc=28&pn=%25E9%2597%25AA%25E9%25AA%258CSDK"><span className="ula">创蓝闪验服务条款和隐私政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        融云SDK: 由北京云中融信网络科技有限公司提供IM即时通讯服务，我们可能会将您的设备信息、位置信息、日志信息提供给网易公司，用于为您提供即时通讯服务（此产品的隐私政策条款，可参考
                        <a href="https://www.rongcloud.cn/privacy"><span className="ula">融云隐私政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        支付宝SDK：由支付宝（中国）网络技术有限公司提供支付服务，我们可能会将您的支付信息提供给支付宝（中国）网络技术有限公司，用于为您提供支付服务（此产品的隐私政策条款，可参考
                        <a href="https://render.alipay.com/p/c/k2cx0tg8"><span className="ula">支付宝隐私政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        微信支付SDK：由财付通支付科技有限公司提供支付服务，我们可能会将您的支付信息提供给财付通支付科技有限公司，用于为您提供支付服务（此产品的隐私政策条款，可参考
                        <a href="https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_business_pay"><span className="ula">微信支付隐私政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        华为HMS SDK:由华为技术有限公司提供，包含华为推送SDK，华为登录SDK，华为支付SDK，提供推送、登录、支付服务，我们可能会将您的SD卡信息、登录信息、支付信息提供给华为技术有限公司，用于为您提供推送、登录、支付服务（此产品的隐私政策条款，可参考
                        <a href="https://support.huawei.com/enterprise/zh/privacy-policy"><span className="ula">华为企业技术支持网站隐私声明</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        VIVO SDK: 由维沃移动通信有限公司提供，包含VIVO推送SDK，为您提供推送、登录、支付服务，我们可能会将您的SD卡信息、登录信息、支付信息提供给维沃移动通信有限公司，用于为您提供推送、登录、支付服务（此产品的隐私政策条款，可参考
                        <a href="https://www.vivo.com.cn/about-vivo/privacy-policy"><span className="ula">VIVO隐私政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        小米SDK: 由北京小米科技有限责任公司提供，包含小米推送SDK，为您提供推送、登录、支付服务，我们可能会将您的SD卡信息、登录信息、支付信息提供给北京小米科技有限责任公司，用于为您提供推送、登录、支付服务（此产品的隐私政策条款，可参考
                        <a href="https://privacy.mi.com/all/zh_CN/"><span className="ula">小米隐私政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        OPPO SDK: 由OPPO广东移动通信有限公司提供，包含OPPO推送SDK，为您提供推送、登录、支付服务，我们可能会将您的SD卡信息、登录信息、支付信息提供给OPPO 广东移动通信有限公司，用于为您提供推送、登录、支付服务（此产品的隐私政策条款，可参考
                        <a href="https://www.oppo.com/cn/privacy/"><span className="ula">oppo隐私政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        魅族 SDK：由珠海市魅族通讯设备有限公司提供，包含魅族推送SDK，为您提供推送、登录、支付服务，我们可能会将您的SD卡信息、登录信息、支付信息提供给珠海市魅族通讯设备有限公司，用于为您提供推送、登录、支付服务（此产品的隐私政策条款，可参考
                        <a href="https://i.flyme.cn/privacy"><span className="ula">魅族隐私政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        高德定位SDK：由高德集团提供，为您在预约了律师见面咨询时便捷的提供一键导航到律师事务所的功能（此产品的隐私政策条款，可参考
                        <a href="https://cache.amap.com/h5/h5/publish/238/index.html"><span className="ula">高德隐私权政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        阿里云 SDK: 由阿里巴巴集团提供，我们可能会将您的SD卡信息、手机号码、IP、登录信息提供给阿里巴巴集团，用于为您提供验证码登录、隐私电话。（此产品的隐私政策条款，可参考
                        <a href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html"><span className="ula">阿里云法律声明及隐私权政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        七牛云 SDK: 由上海七牛信息技术有限公司，我们可能会将您在应用内的图片信息提供给上海七牛信息技术有限公司，为您提供聊天记录历史查询功能（此产品的隐私政策条款，可参考
                        <a href="https://www.qiniu.com/en/privacy-right"><span className="ula">七牛云隐私权政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        友盟SDK：由北京锐讯灵通科技有限公司提供App崩溃报警、用户应用行为统计和推送服务，我们可能会将您的SD卡信息提供给北京锐讯灵通科技有限公司，用于为您提供推送服务（此产品的隐私政策条款，可参考
                        <a href="https://www.umeng.com/terms"><span className="ula">友盟平台服务协议</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        360奇虎SDK：由北京奇虎科技有限公司提供360加固保、应用崩溃的分析，360加固保将会收集您的崩溃日志详情，用于为您下载的app提供加固服务(此产品的隐私政策条款，可参考
                        <a href="https://jiagu.360.cn/#/global/help/295"><span className="ula">360加固保隐私政策</span></a>）；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （3）对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        如我们与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本政策及我们要求其遵守的其他适当的保密和安全措施，我们会对其数据安全能力与环境进行调查，与其签署严格的保密协定，并只会分享特定用途所必要的个人信息。
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移，我们会要求新持有人继续遵守该政策，否则我们将要求其重新获取您的授权。
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        我们还可能为以下情形需要保留、保存或披露您的个人信息：
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （1）与国家安全、国防安全、公共安全、公共卫生、公共利益直接相关的；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （2）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （3）我们认为为遵守适用的法律法规、维护社会公共利益、或保护我们、我们的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需的；
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        （4）法律法规规定的其他情形。
                    </b>
                </p>
                <p className="one">
                    <b>
                        4.2转让
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
                    </b>
                </p>
                <p className="one">
                    在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
                </p>
                <p className="one">
                    在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
                </p>
                <p className="one">
                    <b>
                        4.3公开披露
                    </b>
                </p>
                <p className="desc_block">
                    <b>
                        我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：
                    </b>
                </p>
                <p className="one">
                    根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；
                </p>
                <p className="one">
                    根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。
                </p>
                <p className="one">
                    4.4共享、转让、公开披露个人信息时事先征得授权同意的例外
                </p>
                <p className={`styles.desc_block styles.one`}>
                    以下情形中，我们共享、转让、公开披露您的信息无需事先征得您的授权同意：
                    （1）与国家安全、国防安全直接相关的；
                </p>
                <p className={`styles.desc_block styles.one`}>
                    （2）与公共安全、公共卫生、重大公共利益直接相关的；
                </p>
                <p className={`styles.desc_block styles.one`}>
                    （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；
                </p>
                <p className={`styles.desc_block styles.one`}>
                    （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
                </p>
                <p className={`styles.desc_block styles.one`}>
                    （5）您自行向社会公众公开的个人信息；
                </p>
                <p className={`styles.desc_block styles.one`}>
                    （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                </p>
                <p className={`styles.desc_block styles.one`}>
                    对外共享、转让、公开披露您的个人信息，我们对此负责，并承担相应的法律责任。
                </p>
                <p className="one" id="5">
                    5.我们如何保护您的个人信息
                </p>
                <p className="desc_block">
                    我们非常重视信息安全，我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您向我们提供的个人信息。但请您谅解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。
                </p>
                <p className="desc_block">
                    我们成立了专责团队负责研发和应用多种安全技术和程序等，我们会对安全管理负责人和关键安全岗位的人员进行安全考核，我们建立了完善的信息安全管理制度和内部安全事件处置机制等，我们会采取适当的符合业界标准的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、收到被未经授权的访问、使用、毁损或泄漏。根据我们的安全管理制度，个人信息泄露、毁损或丢失事件被列为重大安全事件，一经发生将启动公司紧急预案，由网络运营部、信息管理部、客户服务部、法务部等多个部门组成联合应急响应小组处理；
                </p>
                <p className="desc_block">
                    我们会对员工进行数据安全的意识培养和安全能力的培训和考核，会对处理个人信息的员工进行身份认证及权限控制，并会与接触您个人信息的员工、合作伙伴签署保密协议，明确岗位职责及行为准则，若有违反保密协议的行为，会被立即终止与我们的劳动或合作关系，并会被追究相关法律责任，对接触个人信息人员在离岗时也提出了保密要求。
                </p>
                <p className="desc_block">
                    在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
                </p>
                <p className="desc_block">
                    同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
                </p>
                <p className="desc_block">
                    我们也请您理解，在互联网行业由于技术的限制和飞速发展以及可能存在的各种恶意攻击手段，即便本单位竭尽所能加强安全措施，也不可能始终保证信息的百分之百安全。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。
                </p>
                <p className="one" id="6">
                    6.您的权利
                </p>
                <p className="desc_block">
                    访问权
                </p>
                <p className="desc_block">
                    原则上您可以通过如下方式访问您的个人信息：
                </p>
                <p>
                    账号信息：您可以随时登录您的个人账号，访问或编辑您的账号中的个人资料信息、更改您的密码、添加安全信息、进行账号关联或身份认证等；

                </p>
                <p>
                    使用信息：您可以在我们的网站、客户端等服务中查阅订单信息等，您也可通过本政策文末提供的方式联系我们删除这些信息，我们将在核实您的身份后提供，但法律法规另有约定的除外；
                </p>
                <p>
                    其他信息：如您在此访问过程中遇到操作问题的或如需获取其他前述无法获知的个人信息内容，您可通过本政策文末提供的方式联系我们，我们将在核实您的身份后提供，但法律法规另有约定的除外。
                </p>
                <p className="desc_block">
                    更正权
                </p>
                <p className="desc_block">
                    经对您的身份进行验证，且更正不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或更新，您可以自行在我们的网站或客户端中进行更正，或在特定情况下，尤其是数据错误时，通过本政策文末提供的联系方式将您的更正申请提交给我们，要求我们更正或更新您的数据，但法律法规另有规定的除外。但出于安全性和身份识别的考虑，您可能无法修改注册时提交的某些初始注册信息。
                </p>
                <p className="desc_block">
                    删除权
                </p>
                <p className="desc_block">
                    您可以自行在我们的网站或客户端中进行删除（点击“我的”）或文末的方式与我们联系，提供相关信息后，我们会帮助您删除个人信息。如我们停止运营或停止提供相关服务，我们将及时停止继续收集您的个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
                </p>

                <p className="desc_block">
                    索取权
                </p>
                <p className="desc_block">
                    如您需要您的个人数据的副本，您可以通过本政策文末提供的方式联系我们，在核实您的身份后，我们将向您提供您在我们的服务中的个人信息副本（例如基本资料、身份信息），但法律法规另有规定的除外。
                </p>

                <p className="desc_block">
                    撤回同意权
                </p>
                <p className="desc_block">
                    如您想更改相关功能的授权范围（例如位置、通讯录、相机），您可以通过您的硬件设备修改个人设置、或在我们的产品或服务中的相关功能设置界面进行操作处理。如您在此过程中遇到操作问题的，可以通过本政策文末提供的方式联系我们。
                </p>

                <p className="desc_block">
                    撤回同意权
                </p>
                <p className="desc_block">
                    如您想更改相关功能的授权范围（例如位置、通讯录、相机），您可以通过您的硬件设备修改个人设置、或在我们的产品或服务中的相关功能设置界面进行操作处理。如您在此过程中遇到操作问题的，可以通过本政策文末提供的方式联系我们。
                </p>
                <p className="desc_block">
                    当您取消相关个人信息收集的授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但您知悉并同意，除非您行使前述c&quot;删除权c&quot;，否则您的该行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
                </p>
                <p className="desc_block">
                    注销权
                </p>
                <p className="desc_block">
                    您可以通过联系我们的客服或通过其他我们公示的方式注销您的账号（但法律法规另有规定的除外），一旦您注销账号，将无法使用我们提供的全线用户产品的服务，因此请您谨慎操作。我们为了保护您或他人的合法权益会结合您对我们提供的各产品的使用情况判断是否支持您的注销请求，比如若您在钱包里有未使用的余额，您还有课程为完结，则我们不会立即支持您的请求，而会提示您先进行相应处理。除法律法规另有规定外，注销账号之后，您该账户内的所有信息将被清空，并根据您的要求删除您的个人信息。您通过第三方账号（如微信、微博、QQ等）授权登录我们的服务时，需要向第三方申请注销账号。
                </p>
                <p className="desc_block">
                    提前获知产品和服务停止运营权
                </p>
                <p className="desc_block">
                    我们愿一直陪伴您，若因特殊原因导致我们部分或全部产品和服务被迫停止运营，我们将提前15日在产品或服务的主页面或站内信或向您发送电子邮件或其他合适的能触达您的方式通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理等，法律法规另有规定的除外。
                </p>
                <p className="desc_block">
                    例外情形
                </p>
                <p className="desc_block">
                    在以下情形中，按照法律法规要求，我们将无法响应您的请求：
                </p>
                <p className="desc_block">
                    与国家安全、国防安全直接相关的；
                </p>
                <p className="desc_block">
                    与公共安全、公共卫生、重大公共利益直接相关的；
                </p>
                <p className="desc_block">
                    与犯罪侦查、起诉、审判和判决执行等直接相关的；
                </p>
                <p className="desc_block">
                    有充分证据表明您存在主观恶意或滥用权利的；
                </p>
                <p className="desc_block">
                    响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
                </p>
                <p className="desc_block">
                    涉及商业秘密的。
                </p>
                <p className="one" id="7">
                    7.我们如何处理儿童的个人信息
                </p>
                <p className="desc_block">
                    如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。如您为未满18周岁的未成年人的，请务必请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。
                </p>
                <p className="desc_block">
                    对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。
                </p>
                <p className="desc_block">
                    如父母或监护人发现相关未成年人信息为未成年人自行填写，需要进行修改或删除处理的，请随时与我们联系。
                </p>
                <p className="desc_block">
                    联系邮箱：526233082@qq.com。
                </p>
                <p className="desc_block">
                    我们收到通知后会第一时间予以响应处理。
                </p>
                <p className="one" id="8">
                    8.您的个人信息如何在全球范围转移
                </p>
                <p className="desc_block">
                    我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：
                </p>
                <p className="desc_block">
                    （1）法律法规有明确规定；
                </p>
                <p className="desc_block">
                    （2）获得您的明确授权；
                </p>
                <p className="desc_block">
                    （3）您通过互联网进行跨境交易等个人主动行为。
                </p>
                <p className="desc_block">
                    针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。
                </p>
                <p className="one" id="9">
                    9.本政策如何更新
                </p>
                <p className="desc_block">
                    我们的隐私政策可能变更。
                </p>
                <p className="desc_block">
                    未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。
                </p>
                <p className="desc_block">
                    对于重大变更，我们还会提供更为显著的通知（包括我们会通过有律可寻官网公示的方式进行通知甚至向您提供弹窗提示）。
                </p>
                <p className="desc_block">
                    本政策所指的重大变更包括但不限于：
                </p>
                <p className="desc_block">
                    （1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
                </p>
                <p className="desc_block">
                    （2）我们在所有权结构、组织架构等方面发生重大变化，如业务调整、破产并购等引起的所有者变更等；
                </p>
                <p className="desc_block">
                    （3）个人信息共享、转让或公开披露的主要对象发生变化；
                </p>
                <p className="desc_block">
                    （4）您参与个人信息处理方面的权利及其行使方式发生重大变化；
                </p>
                <p className="desc_block">
                    （5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
                </p>
                <p className="desc_block">
                    （6）个人信息安全影响评估报告表明存在高风险时。
                </p>
                <p className="one" id="10">
                    10 如何联系我们
                </p>
                <p>
                    您可以通过以下方式与我们联系，我们将在30天内回复您的请求：
                </p>
                <p>
                    （1）如对本政策内容有任何疑问、意见或建议，您可通过电话：0731-85313900与我们联系；
                </p>
                <p>
                    （2）如发现个人信息可能被泄露，您可以通过电话：0731-85313900投诉举报；
                </p>
                <p>
                    （3）我们还设立了个人信息保护专门负责人员，您可以通过邮箱526233082@qq.com与我们联系；
                </p>
                <p>
                    如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，
                </p>
                <p>
                    您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。
                </p>
                <p>
                    运营主体名称：湖南有律可寻网络科技有限公司
                </p>
                <p>
                    注册地址：长沙高新开发区青山路666号湖南省道通科技有限公司厂房3楼302-2号
                </p>
                <p style={{textAlign: "right",paddingBottom:"33px"}}>
                    湖南有律可寻网络科技有限公司
                </p>
            </div>
        </div>
    </div>
    );
}